import { render, staticRenderFns } from "./NewLandingPage.vue?vue&type=template&id=3d15fb80&scoped=true"
import script from "./NewLandingPage.vue?vue&type=script&lang=js"
export * from "./NewLandingPage.vue?vue&type=script&lang=js"
import style0 from "./NewLandingPage.vue?vue&type=style&index=0&id=3d15fb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15fb80",
  null
  
)

export default component.exports